<template>
  <BaseTableWrapper>
    <template #top-buttons>
      <div class="float-right mb-1">
        <router-link tag="button" :to="{ name: 'EXABSurveysCreate' }" class="btn btn-sm btn-primary">{{ $t('buttons.create') }}</router-link>
      </div>
    </template>
    <template #filtering></template>
    <template #body>
      <div v-if="isLoading">
        <Loader></Loader>
      </div>
      <div v-else-if="!isLoading && items.length < 1">
        {{ $t('views.surveys.list.noSurveys') }}
      </div>
      <div v-else>
        <table class="table table-sm table-responsive-md table-striped table-hover">
          <thead>
          <tr>
            <th>{{ $t('global.title') }}</th>
            <th style="width: 5%"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item['@id']">
            <td>{{ item.surveyTitle }}</td>
            <td>
              <div class="btn-group">
                <button type="button" class="btn btn-sm btn-link fa fa-edit fa-lg" @click="editItem(item)" v-b-tooltip.hover :title="$t('buttons.edit')"></button>
                <button type="button" class="btn btn-sm btn-link fa fa-file-check fa-lg" @click="sendSurveyToContractor(item)" v-b-tooltip.hover :title="$t('views.surveys.list.sendSurveyToContractor')"></button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="view">
        <Pagination :view="view" @getPage="getPage($event)"></Pagination>
      </div>
      <SendSurveyToContractorModal />
    </template>
  </BaseTableWrapper>
</template>

<script>
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import Loader from '@/components/Dashboard/Layout/Loader'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import addParamsToQuery from '@/utils/addParamsToQuery'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles'
import SendSurveyToContractorModal from '@/components/Dashboard/Views/AgreementsBundle/surveys/components/SendSurveyToContractorModal.vue'

export default {
  name: 'List',
  components: {
    SendSurveyToContractorModal,
    BaseTableWrapper,
    Pagination,
    Loader
  },
  data () {
    return {
      searchParams: {
        state: 1
      }
    }
  },
  beforeCreate () {
    checkPagePermission('exabagreements', 'EXABSurveysList')
  },
  props: ['item'],
  computed: {
    ...mapGetters({
      error: 'surveys/list/error',
      items: 'surveys/list/items',
      isLoading: 'surveys/list/isLoading',
      view: 'surveys/list/view'
    }),
    ableToCreateSurvey () {
      return checkPermission('exabagreements', 'EXABSurveysCreate')
    }
  },
  created () {
    this.getPage(addParamsToQuery('e_x_a_b_surveys', this.searchParams))
  },
  methods: {
    ...mapActions({
      getPage: 'surveys/list/getItems'
    }),
    editItem (item) {
      this.$router.push({ name: 'EXABSurveysUpdate', params: { id: item['@id'] } })
    },
    sendSurveyToContractor (item) {
      this.toggleSendSurveyToContractorModal()
      this.setSendSurveyToContractorId(item['@id'])
    },
    ...mapMutations({
      toggleSendSurveyToContractorModal: 'surveys/list/toggleSendSurveyToContractorModal',
      setSendSurveyToContractorId: 'surveys/list/setSendSurveyToContractorId'
    })
  }
}
</script>

<style scoped>

</style>
